import { ErrorsHandler } from "components/ui/shared/ErrorsHandler";
import { NotesProvider } from "providers/NotesProvider";
import { ProjectsProvider } from "providers/ProjectsProvider";
import { TasksProvider } from "providers/TasksProvider";
import { RouterProvider } from "react-router-dom";
import { styled } from "styled-components";
import { router } from "./modules/router";

export const AuthenticatedApp = () => {    
    return (
        <ProjectsProvider>
            <TasksProvider>
                <NotesProvider>
                    <AppWrapper>
                        <RouterProvider router={router}/>
                        <ErrorsHandler/>
                    </AppWrapper>
                </NotesProvider>
            </TasksProvider>
        </ProjectsProvider>
        
    );
}

const AppWrapper = styled.div`
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: row;
`
